import React, { useState, useLayoutEffect } from 'react';
import { StyleSheet, SafeAreaView, ScrollView, View } from 'react-native';
import { useSelector } from 'react-redux';
import InputForm from '../components/InputForm';
import { leftMenuHeaderOption, rightFilterHeaderOption } from '../utils/defaultNavOptions';
import { CommonStyles, FontSize, Color, CommonProperties } from '../styles';
import { Modals } from '../constants/ScreenNames';
import MultipleSelect from '../components/SegmentedControl/MultipleSelect';
import InvitationAlert from '../components/alertComponents/InvitationAlert';
import MessageAlert from '../components/alertComponents/MessageAlert';
import IndustryAlert from '../components/alertComponents/IndustryAlert';
import ConnectionRequest from '../components/alertComponents/ConnectionRequest';

import { selectMytrips } from '../store/selectors/mytrips.selector';
import BaseText from '../components/BaseText';
import Icon from '../components/Icon';
import FloatButton from '../components/FloatButton';

const AlertsScreen = (props) => {
  const trips = useSelector(selectMytrips);
  const nextTrip = trips ? trips[0] : null;
  const filters = [
    {
      label: 'Approvals',
      value: null,
    },
    {
      label: 'Savings',
      value: 'Savings',
    },
    {
      label: 'Invites',
      value: 'Invites',
    },
    {
      label: 'Connections',
      value: 'Connections',
    },
    {
      label: 'Messages',
      value: 'Messages',
    },
    {
      label: 'Industry',
      value: 'Industry',
    },
  ];

  const [searchValue, setSearchValue] = useState(null);
  const [filterStatus, setFilterStatus] = useState(null);

  useLayoutEffect(() => {
    props.navigation.setOptions({
      headerTitle: () => (
        <InputForm
          value={searchValue}
          placeholder={'Find Alerts'}
          style={CommonStyles.mb0}
          clearButtonMode="always"
          onChangeText={(text) => {
            setSearchValue(text);
          }}
        />
      ),
      headerTitleAlign: 'left',
      ...rightFilterHeaderOption(() => {
        props.navigation.navigate(Modals.TripFilterModal);
      }),
      ...leftMenuHeaderOption(props),
    });
  }, [props, setSearchValue, searchValue]);

  return (
    <SafeAreaView style={styles.pageContainer}>
      <MultipleSelect
        items={filters}
        onChange={(value) => {
          setFilterStatus(value);
        }}
        selected={filterStatus}
      />
      {filterStatus === null && (
        <View style={styles.noUpdateContent}>
          <View style={styles.messageContainer}>
            <BaseText style={styles.headMessage}>No updates</BaseText>
            <BaseText style={styles.message}>
              You will se important notifications and updates here
            </BaseText>
          </View>
          <View style={styles.messageIcon}>
            <Icon size={100} name={'messageAlert'} color={Color.disabled} />
          </View>
        </View>
      )}
      <ScrollView style={[CommonStyles.flex1, CommonStyles.py3]}>
        {filterStatus === 'Savings' && <InvitationAlert type={'Savings'} trip={nextTrip} />}
        {filterStatus === 'Invites' && <InvitationAlert type={'Invitation'} trip={nextTrip} />}
        {filterStatus === 'Connections' && (
          <ConnectionRequest type={'Connection'} trip={nextTrip} />
        )}
        {filterStatus === 'Connections' && <ConnectionRequest trip={nextTrip} />}
        {filterStatus === 'Industry' && <IndustryAlert type={'Company'} trip={nextTrip} />}
        {filterStatus === 'Industry' && <IndustryAlert type={'Advisory'} trip={nextTrip} />}
        {filterStatus === 'Messages' && <MessageAlert trip={nextTrip} />}
      </ScrollView>
      <FloatButton
        onPress={() => props.navigation.navigate(Modals.TravelerSafetyModal)}
        iconName="mark"
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  pageContainer: {
    flex: 1,
    backgroundColor: Color.accent,
  },
  messageContainer: {
    flex: 1,
    alignItems: 'center',
    ...CommonProperties.mt5,
    ...CommonProperties.mx5,
  },
  headMessage: {
    fontSize: FontSize.h1,
  },
  messageIcon: {
    flex: 2,
    alignItems: 'center',
  },
  message: {
    ...CommonProperties.mx5,
    textAlign: 'center',
    fontSize: FontSize.h3,
  },
  noUpdateContent: {
    flexDirection: 'column',
    flex: 1,
  },
});

export default AlertsScreen;
